module.exports = __webpack_public_path__ + "static/media/photo_booth.41379b05.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/about/photo_booth.png
// module id = 230
// module chunks = 0